module.exports = __webpack_public_path__ + "static/media/copy-icon.541e56be.svg";